import axios from 'axios';
// Base axios instance cho toàn bộ app
// TODO: nếu deploy, đổi lại baseURL cho phù hợp môi trường
export const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_ENVIRONMENT === 'staging' ? 'https://dev.vanhanh68.com' : process.env.NODE_ENV === 'production' ? 'https://wh.vanhanh68.com' : 'http://localhost:8300',
  timeout: 10000,
});

axiosClient.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem('token');
    // if (token) config.headers.Authorization = `Bearer ${token}`;
    config.headers.privateKey = 'sbc@$#@2026';
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    return Promise.reject(error);
  }
);

